module.exports = __webpack_public_path__ + "img/title.dbbdb45b.jpg";